// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"4264c829","2761":"028edabf","2866":"028edabf","4257":"028edabf"}[chunkId] + ".chunk.css";
};